import { useEffect } from 'react'

import { useRouteError } from 'react-router-dom'
import { useAppInfo } from 'hooks/useAppInfo'
import { handleBackButton, normalizeLanguage } from 'utils'

import { AppBar } from '@interco/inter-ui/components/AppBar'
import { FlexColumn } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { interWbSession } from '@interco/inter-webview-bridge'

import { IconTheme } from '../IconTheme'
import { data } from './data'

export function RouteError() {
  const error = useRouteError()
  const { language } = useAppInfo()
  const texts = data[normalizeLanguage(language)]

  useEffect(() => {
    interWbSession.requestAnalytics('GLOBAL_ACCOUNT_WEBVIEW', {
      eventId: 'ROUTE_ERROR',
      path: window.location.pathname,
      error: error instanceof Error ? error.toString() : JSON.stringify(error) ?? '',
    })
  }, [error])

  return (
    <>
      <AppBar
        leftIcon={
          <IconTheme
            icon="orangeds/MD/arrow-left"
            width={24}
            height={24}
            onClick={handleBackButton}
          />
        }
      />
      <FlexColumn gap="8px" className="p-4">
        <Text variant="headline-h3" as="h1" semiBold>
          {texts.title}
        </Text>
        <Text variant="body-3" as="p">
          {texts.description}
        </Text>
      </FlexColumn>
    </>
  )
}
